module.exports = __webpack_public_path__ + "static/media/bg1.0e0d9d62.png";